import { registerPlugin } from '@capacitor/core';

/**
 * DivineAlarm — Custom native AlarmManager plugin.
 * Supports interval, daily, and date-based alarms.
 * Works even when app is killed or phone is restarted.
 */

export type AlarmType = 'divine_reminder' | 'sadhana' | 'shlok' | 'jaap_incomplete' | 'ekadashi';

interface ScheduleResult {
  success: boolean;
  type: string;
  alarmsScheduled: number;
}

interface StatusResult {
  enabled: boolean;
  mode: string;
  intervalMinutes: number;
  hour: number;
  minute: number;
  title: string;
  body: string;
  soundName: string;
}

interface DivineAlarmPlugin {
  /** Schedule repeating interval alarms (divine_reminder, jaap_incomplete) */
  scheduleInterval(options: {
    type: AlarmType;
    intervalMinutes: number;
    title: string;
    body: string;
    soundName: string;
  }): Promise<ScheduleResult>;

  /** Schedule daily fixed-time alarms (sadhana, shlok) */
  scheduleDaily(options: {
    type: AlarmType;
    hour: number;
    minute: number;
    title: string;
    body: string;
    soundName: string;
  }): Promise<ScheduleResult>;

  /** Schedule date-based alarms (ekadashi) */
  scheduleOnDates(options: {
    type: AlarmType;
    timestamps: number[];
    title: string;
    body: string;
    soundName: string;
  }): Promise<ScheduleResult>;

  /** Cancel specific alarm type */
  cancel(options: { type: AlarmType }): Promise<{ success: boolean; type: string }>;

  /** Cancel ALL alarm types */
  cancelAll(): Promise<{ success: boolean }>;

  /** Get status of specific alarm type */
  getStatus(options: { type: AlarmType }): Promise<StatusResult>;
}

const DivineAlarm = registerPlugin<DivineAlarmPlugin>('DivineAlarm');

export default DivineAlarm;
